import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { selectUserInfo } from "../auth.ducks";
import { checkEmptyObject } from "../../../services";
import history from "../../../history";
import { VerifyModalI } from "../../../models/enums";
import { UserI } from "../../../typings/interfaces";
import VerifyModal from "../../../components/VerifyModal";
import styles from "../../../containers/App/app.scss";
import { getVerifyModalContent } from "../../../services/getVerifyModalContent";


export interface UsernameChangeRequiredProps {
  history?: History;
  location?: Location;
  match?: { path: string; url: string; isExact: boolean; params: {} };
  staticContext?: any;
  user?: UserI | null;
}


const blankVerifyModal: VerifyModalI = {
  heading: "",
  content: "",
  redirectPath: ""
};

export default (Com: Function) => {
  const UsernameChangeRequiredComponent = (props: UsernameChangeRequiredProps) => {
    const { user } = props;

    const [verifyModal, setVerifyModal] = useState(blankVerifyModal);

    useEffect(() => {
      if (checkEmptyObject(user) && user.hasInvalidUsername) {
        setVerifyModal(getVerifyModalContent(user));
      }
    }, [user]);

    return checkEmptyObject(user) && !user.hasInvalidUsername ? (
      <React.Fragment>
        <Com {...props} />
      </React.Fragment>
    ) : (
      <VerifyModal
        visible={verifyModal.heading !== "" && verifyModal.content !== "" && verifyModal.redirectPath !== ""}
        onOk={() => {
          history.push(verifyModal.redirectPath), setVerifyModal(blankVerifyModal);
        }}
        onCancel={() => {
          history.replace("/"), setVerifyModal(blankVerifyModal);
        }}
        onClose={() => setVerifyModal(blankVerifyModal)}
        closable={false}
        className={styles.modal}
        {...verifyModal}
      />
    );
  };

  return connect(
    state => ({
      user: selectUserInfo(state)
    }),
    null
  )(UsernameChangeRequiredComponent);
};


// WEBPACK FOOTER //
// ./src/routes/Auth/HOCs/requireUsernameChange.tsx